var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.banner.savePath!==null)?_c('div',{staticClass:"banner-inner",attrs:{"height":_vm.bannerHeight+'px'}},[_c('img',{ref:"bannerHeight",staticStyle:{"width":"100%"},attrs:{"src":_vm.banner.savePath,"alt":""},on:{"load":_vm.imgLoad}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }